export default "__VITE_ASSET__a2f727f1__"